export abstract class Transacao {
    id: string
    empresa: string
    data: Date
    tipoDeVenda: string
    bandeira: string
    estabelecimento: string
    valorBruto: number
    valorLiquido: number
    taxaDaOperadora: number

    get possuiValorBruto() {
        return this.valorBruto !== 0
    }
}



// WEBPACK FOOTER //
// ./src/app/pkw-data/collect/extrato/transacao.model.ts